import { useRef, useEffect, useState } from 'react';
import {
 Center,
 Container,
 Heading,
 Text,
 Grid,
 Stack,
 Flex,
 Box,
} from '@chakra-ui/react';
import Tag from '../Tags/Simple';
import StatusTag from '../Tags/StatusTag';

const QuestionnaireHeader = ({
 tagLabel,
 heading,
 totalQuestions,
 endDate,
 children,
 status,
 companyName,
}) => {
 const headingRef = useRef(null);
 const [headingWidth, setHeadingWidth] = useState(0);
 const BANNER_HEIGHT = '44px';
 const HEADER_HEIGHT = '174px';

 useEffect(() => {
  if (headingRef?.current) {
   setHeadingWidth(headingRef?.current?.offsetWidth);
  }
 }, []);

 return (
  <>
   <Box
    position='fixed'
    top={BANNER_HEIGHT}
    left={0}
    right={0}
    height={HEADER_HEIGHT}
    zIndex={999}
    bg='white'
    borderBottom='1px solid #E5E5E5'
   >
    <Center minH={HEADER_HEIGHT} maxH={HEADER_HEIGHT} px='86px'>
     <Container maxW='1280px' p={0} overflowX='hidden'>
      <Grid
       templateColumns={['repeat(1, 1fr)', 'repeat(3, 1fr)']}
       py='32px'
       px={['24px', 'unset']}
       alignItems='center'
       gap={4}
      >
       <Stack spacing='0' align='start'>
        <Flex gap='8px'>
         {companyName && <Tag label={companyName} variant='default' />}

         {tagLabel && (
          <Tag
           label={tagLabel}
           variant='default'
           {...(companyName && { bg: '#00B2EF' })}
          />
         )}
        </Flex>

        <Flex direction='column'>
         <Flex ref={headingRef} align='center' gap='4' m={['4px 0 8px', '12px 0 8px']}>
          <Heading
           fontSize='22px'
           lineHeight='26.18px'
           textOverflow='ellipsis'
           overflow='hidden'
          >
           {heading}
          </Heading>
          <StatusTag status={status} />
         </Flex>
         <Flex w={`${headingWidth || '150'}px`} h='1px' bg='#ADAFB3' mb='12px' />
        </Flex>

        <Text
         fontSize={['13px', 'sm']}
         lineHeight='16.44px'
         color='#818A8F'
         pos='relative'
         w={headingWidth}
         display={['none', 'flex']}
         flexWrap='nowrap'
         gap='12px'
        >
         <Text as='span' whiteSpace='nowrap'>
          {totalQuestions}
         </Text>
         <Text as='span' whiteSpace='nowrap'>
          {endDate}
         </Text>
        </Text>
       </Stack>
       {children}
      </Grid>
     </Container>
    </Center>
   </Box>
   <Box height={`calc(${BANNER_HEIGHT} + ${HEADER_HEIGHT})`} />
  </>
 );
};

export default QuestionnaireHeader;
